import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/layout/Layout";
import Home from "@/pages/Home";
import Solutions from "@/pages/Solutions";
import Services from "@/pages/Services";
import Industries from "@/pages/Industries";
import CaseStudies from "@/pages/CaseStudies";
import Insights from "@/pages/Insights";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import BookCall from "@/pages/BookCall";
import Partners from "@/pages/Partners";
import Careers from "@/pages/Careers";
import Privacy from "@/pages/Privacy";
import SocTech from "@/pages/SocTech";
import HRPortal from "@/pages/HRPortal";
import LeadsManagement from "@/pages/LeadsManagement";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* HR Portal - standalone without main layout */}
        <Route path="/hr-portal" element={<HRPortal />} />
        
        {/* CRM Leads Management - standalone without main layout */}
        <Route path="/crm/leads" element={<LeadsManagement />} />
        
        {/* Main site with layout */}
        <Route path="/*" element={
          <Layout>
            <Routes>
              {/* Home */}
              <Route path="/" element={<Home />} />
              
              {/* Solutions */}
              <Route path="/solutions/data-engineering" element={<Solutions type="data-engineering" />} />
              <Route path="/solutions/reporting" element={<Solutions type="reporting" />} />
              <Route path="/solutions/dmrv" element={<Solutions type="dmrv" />} />
              <Route path="/solutions/tokenization" element={<Solutions type="tokenization" />} />
              <Route path="/solutions/credibility-engine" element={<Solutions type="credibility-engine" />} />
              <Route path="/solutions/soctech" element={<SocTech />} />
              
              {/* Services */}
              <Route path="/services" element={<Services />} />
              <Route path="/services/materiality-assessment" element={<Services type="materiality-assessment" />} />
              <Route path="/services/esg-reporting" element={<Services type="esg-reporting" />} />
              <Route path="/services/esg-outsourcing" element={<Services type="esg-outsourcing" />} />
              <Route path="/services/strategy-program-design" element={<Services type="strategy-program-design" />} />
              <Route path="/services/data-curation" element={<Services type="data-curation" />} />
              <Route path="/services/training-enablement" element={<Services type="training-enablement" />} />
              
              {/* Industries */}
              <Route path="/industries/real-estate" element={<Industries type="real-estate" />} />
              <Route path="/industries/manufacturing" element={<Industries type="manufacturing" />} />
              <Route path="/industries/logistics" element={<Industries type="logistics" />} />
              <Route path="/industries/hospitality" element={<Industries type="hospitality" />} />
              <Route path="/industries/public-sector" element={<Industries type="public-sector" />} />
              <Route path="/industries/itbpm" element={<Industries type="itbpm" />} />
              
              {/* Other Pages */}
              <Route path="/case-studies" element={<CaseStudies />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/book-call" element={<BookCall />} />
              <Route path="/partners" element={<Partners />} />
              
              {/* Legal & Career Pages */}
              <Route path="/careers" element={<Careers />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Contact />} />
              
              {/* Catch-all route */}
              <Route path="*" element={<Home />} />
            </Routes>
          </Layout>
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
